import { useSelector } from 'react-redux';

const useIsAuth = (): boolean => {
  return useSelector<any, boolean>((state) => state?.auth?.isAuthenticated === true);
};
export default useIsAuth;
